import { FC } from 'react';

export const SearchResultSkeleton: FC<
  React.PropsWithChildren<unknown>
> = () => {
  return <div className="h-16 w-104 mx-auto sm:mx-0 bg-base-lighter-16" />;
};
